import { type ReactNode } from 'react';

export function MobileFrame({ children }: { children: ReactNode }) {
    return (
        <div className="min-h-dvh bg-zinc-950 md:flex md:items-center md:justify-center md:py-6 md:min-h-screen">
            <div className="relative mx-auto min-h-dvh w-full max-w-full bg-zinc-950 md:min-h-0 md:h-[852px] md:w-[414px] md:max-w-[414px] md:rounded-[40px] md:border md:border-zinc-800 md:shadow-2xl md:overflow-hidden">
                {children}
            </div>
        </div>
    );
}
